export default {
    title: 'Components/Cards/Team Member Card',
    // tags: ['autodocs'],
    argTypes: {
      image_src: {
        control: 'text',
        description: 'Path to the image of the team member',
      },
      image_alt: {
        control: 'text',
        description: 'alternate text of the image',
      },
      team_member_name: {
        control: 'text',
        description: 'Name of the team member',
      },
      team_member_position: {
        control: 'text',
        description: 'Position of the team member',
      },
      design: {
        control: { type: 'select' },
        options: ['default', 'blue'],
        description: 'Design variation of the credit card',
      },
      custom_class: {
        control: { type: 'text' },
        description: 'Custom class for the credit card component',
      },
      component_mode: {
        control: { type: 'check' },
        options: ['light-mode'],
        description: 'Mode of the credit card component',
      }
    },
    parameters: {
      docs: {
        description: {
          component: `
  To use the \`dda-team-member-card\` component, pass the following props:
  
  \`\`\`html
<dda-team-member-card
    image_src="https://img.freepik.com/premium-vector/traditional-arabic-man-head-icon-vector-avatar_55610-6301.jpg"
    image_alt="Omar Al-Hamadi"
    team_member_name="Omar Al-Hamadi"
    team_member_position="Chief Executive Officer"
    design="default"
    custom_class=""
    component_mode=""
></dda-team-member-card>
    \`\`\`
  `,
        },
      },
    },  
  };
  
  const Template = (args) => {
    const attributes = Object.entries(args)
      .filter(([key, value]) => value !== undefined && key !== 'text')
      .map(([key, value]) => `${key}="${value}"`)
      .join(' ');
  
    return `<dda-team-member-card ${attributes}></dda-team-member-card>`;
  };
  
  export const Default = Template.bind({});
  Default.args = {
    image_src: 'https://img.freepik.com/premium-vector/traditional-arabic-man-head-icon-vector-avatar_55610-6301.jpg',
    image_alt: 'Omar Al-Hamadi',
    team_member_name: 'Omar Al-Hamadi',
    team_member_position: 'Chief Executive Officer',
    design: 'default',
    custom_class: '',
    component_mode: '',
  };
  
  export const Blue = Template.bind({});
  Blue.args = {
    image_src: 'https://img.freepik.com/premium-vector/traditional-arabic-man-head-icon-vector-avatar_55610-6301.jpg',
    image_alt: 'Omar Al-Hamadi',
    team_member_name: 'Omar Al-Hamadi',
    team_member_position: 'Chief Executive Officer',
    design: 'blue',
    custom_class: '',
    component_mode: '',
  };  